import Web3 from "web3";
import { Interface } from "@ethersproject/abi";
import web3NoAccount from "../utils/web3";
import { BigNumber } from "@ethersproject/bignumber";
import { getMulticallContract } from "./contractHelpers";

interface Call {
  address: string; // Address of the contract
  name: string; // Function name on the contract (example: balanceOf)
  params?: any[]; // Function params
}

interface MulticallOptions {
  web3?: Web3;
  blockNumber?: number;
  requireSuccess?: boolean;
}

const MaxUint256: BigNumber = /*#__PURE__*/ BigNumber.from(
  "0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"
);

export const buyNFT = async (contract, nftType, quantity, account) => {
  return contract.methods
    .buy(nftType, quantity)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const sellNFT = async (contract, tokenId, account) => {
  return contract.methods
    .sell(tokenId)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const approveForAll = async (contract, operator, account) => {
  return contract.methods
    .setApprovalForAll(operator, true)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const recordReferral = async (account, recordReferralContract, ref) => {
  return recordReferralContract.methods
    .addReferral(ref)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const approve = async (account, contract, spender) => {
  return contract.methods
    .approve(spender, MaxUint256)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const transferNFT = async (account, contract, to, tokenId) => {
  return contract.methods
    .transferFrom(account, to, tokenId)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const stake = async (account, contract, ids, referrer) => {
  return contract.methods
    .deposit(ids, referrer)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const stakeCloud = async (account, contract, pid, amount) => {
  return contract.methods
    .deposit(pid, amount)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const harvest = async (account, contract, packageId) => {
  return contract.methods
    .harvest(packageId)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const harvestAll = async (account, contract) => {
  return contract.methods
    .harvestAll()
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const withdrawInvestment = async (account, contract, pid) => {
  return contract.methods
    .withdrawInvestment(pid)
    .send({ from: account })
    .on("transactionHash", (tx) => {
      return tx.transactionHash;
    });
};

export const multicall = async (
  abi: any[],
  calls: Call[],
  options: MulticallOptions = {}
) => {
  try {
    const multi = getMulticallContract(options.web3 || web3NoAccount);
    const itf = new Interface(abi);

    const calldata = calls.map((call) => [
      call.address.toLowerCase(),
      itf.encodeFunctionData(call.name, call.params),
    ]);
    const { returnData } = await multi.methods
      .aggregate(calldata)
      .call(undefined, options.blockNumber);
    const res = returnData.map((call, i) =>
      itf.decodeFunctionResult(calls[i].name, call)
    );

    return res;
  } catch (error) {
    console.log(error);
    throw new Error();
  }
};
